import { ReactNode } from 'react';
import {
  Header,
  Footer,
  Preloader,
  QuickViewModal,
  ScrollUp,
  WishlistModal,
  ShareDialog,
} from './components';
import { useProperties } from '@providers';
import { PropertyFiltersModal } from './components/PropertyFiltersModal.tsx';

type LayoutProps = {
  children: ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
  const { culture } = useProperties();

  return (
    <>
      <div className='body-wrapper' lang={culture}>
        <Header />
        {children}
        <Footer />
        <PropertyFiltersModal />
        <QuickViewModal />
        <ShareDialog />
        <WishlistModal />
      </div>
      <ScrollUp />
      <Preloader />
    </>
  );
};
